import React, { useEffect, useState, useRef } from "react";
import "./Animations.css";

// FIXED Custom Cursor
export function CustomCursor() {
  const cursorRef = useRef(null);
  const cursorDotRef = useRef(null);

  useEffect(() => {
    let mouseX = 0;
    let mouseY = 0;
    let cursorX = 0;
    let cursorY = 0;
    let cursorDotX = 0;
    let cursorDotY = 0;

    const moveCursor = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    };

    const animate = () => {
      cursorX += (mouseX - cursorX) * 0.15;
      cursorY += (mouseY - cursorY) * 0.15;
      cursorDotX += (mouseX - cursorDotX) * 0.8;
      cursorDotY += (mouseY - cursorDotY) * 0.8;

      if (cursorRef.current) {
        cursorRef.current.style.transform = `translate3d(${cursorX}px, ${cursorY}px, 0)`;
      }
      if (cursorDotRef.current) {
        cursorDotRef.current.style.transform = `translate3d(${cursorDotX}px, ${cursorDotY}px, 0)`;
      }

      requestAnimationFrame(animate);
    };

    window.addEventListener("mousemove", moveCursor);
    animate();

    const handleMouseOver = (e) => {
      const target = e.target.closest(
        "a, button, .project-card, .skill-category, .certification-card"
      );
      if (target) {
        if (cursorRef.current) cursorRef.current.classList.add("hover");
        if (cursorDotRef.current) cursorDotRef.current.classList.add("hover");
      } else {
        if (cursorRef.current) cursorRef.current.classList.remove("hover");
        if (cursorDotRef.current)
          cursorDotRef.current.classList.remove("hover");
      }
    };

    document.addEventListener("mouseover", handleMouseOver);

    return () => {
      window.removeEventListener("mousemove", moveCursor);
      document.removeEventListener("mouseover", handleMouseOver);
    };
  }, []);

  return (
    <>
      <div ref={cursorDotRef} className="custom-cursor-dot"></div>
      <div ref={cursorRef} className="custom-cursor-ring"></div>
    </>
  );
}

// Click Spark
export function ClickSpark() {
  const [sparks, setSparks] = useState([]);

  useEffect(() => {
    const handleClick = (e) => {
      const spark = {
        id: Date.now() + Math.random(),
        x: e.clientX,
        y: e.clientY,
      };

      setSparks((prev) => [...prev, spark]);

      setTimeout(() => {
        setSparks((prev) => prev.filter((s) => s.id !== spark.id));
      }, 1000);
    };

    window.addEventListener("click", handleClick);
    return () => window.removeEventListener("click", handleClick);
  }, []);

  return (
    <div className="click-spark-container">
      {sparks.map((spark) => (
        <div
          key={spark.id}
          className="spark-burst"
          style={{
            left: `${spark.x}px`,
            top: `${spark.y}px`,
          }}
        >
          {[...Array(8)].map((_, i) => (
            <div
              key={i}
              className="spark-particle"
              style={{
                "--angle": `${i * 45}deg`,
              }}
            />
          ))}
        </div>
      ))}
    </div>
  );
}

// Dock
export function Dock() {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const dockItems = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
          <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
        </svg>
      ),
      label: "GitHub",
      href: "https://github.com/MayankGupt10",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
          <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
        </svg>
      ),
      label: "LinkedIn",
      href: "https://www.linkedin.com/in/mayank8",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
          <path d="M0 3v18h24v-18h-24zm6.623 7.929l-4.623 5.712v-9.458l4.623 3.746zm-4.141-5.929h19.035l-9.517 7.713-9.518-7.713zm5.694 7.188l3.824 3.099 3.83-3.104 5.612 6.817h-18.779l5.513-6.812zm9.208-1.264l4.616-3.741v9.348l-4.616-5.607z" />
        </svg>
      ),
      label: "Email",
      href: "mailto:mayankgupta0619@gmail.com",
    },
  ];

  return (
    <div className="dock-container">
      <div className="dock">
        {dockItems.map((item, index) => (
          <a
            key={index}
            href={item.href}
            target={item.href.startsWith("http") ? "_blank" : "_self"}
            rel={item.href.startsWith("http") ? "noopener noreferrer" : ""}
            className="dock-item"
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            style={{
              transform: `scale(${
                hoveredIndex === index
                  ? 1.5
                  : hoveredIndex === index - 1 || hoveredIndex === index + 1
                  ? 1.2
                  : 1
              }) translateY(${hoveredIndex === index ? "-10px" : "0"})`,
            }}
          >
            {item.icon}
            <span className="dock-tooltip">{item.label}</span>
          </a>
        ))}
      </div>
    </div>
  );
}

// FIXED Gooey Nav - Correct blob positioning
export function GooeyNav() {
  const [activeIndex, setActiveIndex] = useState(0);

  const navItems = [
    { label: "Home", id: "home" },
    { label: "About", id: "about" },
    { label: "Experience", id: "experience" },
    { label: "Projects", id: "projects" },
    { label: "Skills", id: "skills" },
    { label: "Certifications", id: "certifications" },
    { label: "Contact", id: "contact" },
  ];

  const scrollToSection = (id, index) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setActiveIndex(index);
    }
  };

  // Calculate blob position based on active index
  // Each button is approximately 44px height + 6px gap = 50px total
  const blobPosition = 12 + activeIndex * 44; // Starting padding + (index * button height)

  return (
    <>
      <div className="gooey-nav-container">
        <nav className="gooey-nav">
          <div
            className="gooey-blob"
            style={{
              top: `${blobPosition}px`,
            }}
          />
          {navItems.map((item, index) => (
            <button
              key={index}
              className={`gooey-nav-item ${
                activeIndex === index ? "active" : ""
              }`}
              onClick={() => scrollToSection(item.id, index)}
            >
              {item.label}
            </button>
          ))}
        </nav>
      </div>

      <svg style={{ position: "absolute", width: 0, height: 0 }}>
        <defs>
          <filter id="gooey">
            <feGaussianBlur
              in="SourceGraphic"
              stdDeviation="10"
              result="blur"
            />
            <feColorMatrix
              in="blur"
              mode="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
              result="goo"
            />
            <feBlend in="SourceGraphic" in2="goo" />
          </filter>
        </defs>
      </svg>
    </>
  );
}

export default function Animations() {
  return (
    <>
      <CustomCursor />
      <ClickSpark />
      <Dock />
      <GooeyNav />
    </>
  );
}
